/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgJoinDiagram = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21 8h-6.723L10 10.565v3.02L12.414 16H19v6h-8v-4.586L8.586 15H2V9h6.723L13 6.434V2h8v6zm-8 12h4v-2h-4v2zm-9-7h4v-2H4v2zm11-7h4V4h-4v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgJoinDiagram as JoinDiagram };
